import backend from 'i18next-http-backend';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LS_LANGUAGE_KEY, SUPPORTED_LANGUAGES } from '../config';

type GetCustomLangPathType = (lngs: string[]) => string | undefined;
// если функция возвращяет undefined, то файл локализации не загружаеться
// return '/locales/en/translation.json' или кастомный путь из паблик

const getCustomLangPath: GetCustomLangPathType = (lngs) => {
  const lang = lngs[0];

  return `/locale/${lang}/translation.json`;
};

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem(LS_LANGUAGE_KEY) || 'en',
    fallbackLng: 'en',
    preload: ['en'],
    backend: {
      loadPath: getCustomLangPath
    },
    lowerCaseLng: true,
    load: 'languageOnly',
    supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
    interpolation: {
      escapeValue: false
    },
    returnNull: false
  });

export default i18n;
